import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "mt-4 p-2 bg-white dark:border-gray-800 rounded-md shadow-md" }
const _hoisted_5 = { class: "mt-2 p-1 bg-white dark:border-gray-800 rounded-md shadow-md" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }

import { onMounted, provide, ref, watch } from 'vue';
  import CalculatorNotes from '@/components/calculator/CalculatorNotes.vue';
  import InputCustom from '@/components/components/inputCustom.vue';
  import ButtonCustom from '@/components/components/buttonCustom.vue';
  import RadioBtnGroup from '@/components/components/radioBtnGroup.vue';
  import PageNavigation from '@/components/components/PageNavigation.vue';
  import SliderWithModal from '@/components/components/SliderWithModal.vue';
  import DealerInfo from '@/components/components/dealerInfo.vue';
  import DocumentInfo from '@/components/components/documentInfo.vue';
  import MainCalcBlock from '@/components/calculator/mainCalcBlock.vue';
  import TotalCalcBlock from '@/components/calculator/TotalCalcBlock.vue';
  import { useParser } from '@/store/parser';
  import {
    calcPensionCost,
    getFreeACopart,
    getFreeAIAAI,
    getLiveBindCopart,
    getLiveBindIAAI,
    localstorageGet,
    localstorageSet,
  } from '@/helpers/helper';
  import { additionalCosts, carData } from '@/types';
  import { getSession, saveCar } from '@/indexedDB';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CalculatorSearchCar',
  props: {
    carData: {},
    additionalFields: {}
  },
  setup(__props: any) {

  const props = __props;

  const link = ref<string>(localstorageGet('link') ?? '');
  const activeTab = ref<number>(1);
  const loading = ref<boolean>(false);
  const additionalFields = ref<additionalCosts | null>(props.additionalFields);
  const dataCar = ref<carData | null>(props.carData);

  const auction = ref<string>(dataCar.value?.info?.countryCalc ?? 'poland');
  const { parseLink, getCustomClearance, getCurrencyCourse } = useParser();

  // Сохранение link в localStorage
  watch(link, (newLink) => {
    localstorageSet('link', newLink);
  });
  provide('link', link);

  async function updateAuctionFee() {
    const priceNow = +dataCar.value?.info?.priceNow || 0;
    if (link.value.includes('copart')) {
      dataCar.value.info.auctionFee =
        getLiveBindCopart(priceNow) + getFreeACopart(priceNow) + 95 + 35;
    } else {
      dataCar.value.info.auctionFee =
        getLiveBindIAAI(priceNow) + getFreeAIAAI(priceNow) + 140 + 25;
    }
    await saveCar('car', dataCar.value);
  }

  // Обработка клика "Scan"
  async function parseCar() {
    loading.value = true;
    dataCar.value = await parseLink(link.value, auction.value);
    // Устанавливаем значения по умолчанию
    dataCar.value.shipping.body = 'Crossover';
    dataCar.value.shipping.costShippingInsurance = 75;
    dataCar.value.info.countryCalc = auction.value;
    await updateAuctionFee();
    if (
      dataCar.value.info.countryCalc === 'ukraine' ||
      dataCar.value.info.countryCalc === 'poland'
    ) {
      additionalFields.value.customsCost = await getCustomClearance(
        auction.value,
        dataCar.value
      );
    }

    additionalFields.value.pensionCost = 0;
    if (dataCar.value.info.countryCalc === 'ukraine') {
      const course = await getCurrencyCourse();

      additionalFields.value.pensionCost = calcPensionCost(
        +dataCar.value.info.priceNow,
        +course,
        +dataCar.value.info.auctionFee
      );
    }

    if (dataCar.value?.info.countryCalc === 'poland') {
      additionalFields.value.parkingCost = 0;
      additionalFields.value.towingCost = 0;
    }

    if (dataCar.value?.info.countryCalc === 'georgy') {
      additionalFields.value.parkingCost = 0;
      additionalFields.value.towingCost = 0;
      additionalFields.value.expeditionCost = 0;
      additionalFields.value.certification = 0;
      additionalFields.value.customsCost = 0;
    }

    localstorageSet(
      'auctionName',
      link.value.includes('copart') ? 'copart' : 'iaai'
    );
    localstorageSet('readNews', false);
    activeTab.value = 2;
    await saveCar('car', dataCar.value);
    await saveCar('additionalFields', additionalFields.value);
    localStorage.removeItem('analytics');
    loading.value = false;
  }

  onMounted(async () => {
    const sessionCar = await getSession('car');
    if (sessionCar) dataCar.value = sessionCar;
    const sessionAdditional = await getSession('additionalFields');
    if (sessionAdditional) additionalFields.value = sessionAdditional;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (Object.keys(dataCar.value?.info ?? {}).length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(PageNavigation, {
            title: "Pages",
            totalPages: dataCar.value?.info?.countryCalc === 'georgy' ? 3 : 4,
            activePage: activeTab.value,
            key: activeTab.value,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = (page) => (activeTab.value = page))
          }, null, 8, ["totalPages", "activePage"]))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (activeTab.value === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass([{ 'mt-4': dataCar.value }, "p-2 bg-white dark:border-gray-800 rounded-md shadow-md"])
            }, [
              _createVNode(InputCustom, {
                modelValue: link.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((link).value = $event))
              }, null, 8, ["modelValue"])
            ], 2),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(RadioBtnGroup, {
                modelValue: auction.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((auction).value = $event)),
                options: [
              { key: 'poland', label: 'Poland' },
              { key: 'georgy', label: 'George' },
              { key: 'ukraine', label: 'Ukraine' },
            ]
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(ButtonCustom, {
                title: "Scan",
                loading: loading.value,
                disable: !link.value || !auction.value,
                onClick: parseCar
              }, null, 8, ["loading", "disable"])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(CalculatorNotes, {
              country: dataCar.value.info.countryCalc
            }, null, 8, ["country"]),
            _createVNode(DocumentInfo, {
              data: dataCar.value.info
            }, null, 8, ["data"]),
            _createVNode(DealerInfo, {
              data: dataCar.value.info
            }, null, 8, ["data"]),
            _createVNode(SliderWithModal, {
              images: 
            dataCar.value.img.filter((value) => value.imageTypeCode !== 'ENAUD')
          
            }, null, 8, ["images"])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(), _createBlock(MainCalcBlock, { key: activeTab.value }))
          ]))
        : _createCommentVNode("", true),
      (dataCar.value?.info?.countryCalc !== 'georgy' && activeTab.value === 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(), _createBlock(TotalCalcBlock, { key: activeTab.value }))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})